import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Chip,
  Tabs,
  Tab,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import eventEmitter from "../utils/eventEmitter";
import { setConfigDiffData } from "../../pages/onPremises/ConfigDiff/ConfigDiff-slice";
const AssetDetailsDrawer = React.lazy(() => import("../asset/AssetDetailsDrawer"));
import AssetComplianceReportDrawer from "../asset/AssetComplianceReportDrawer";
import { ICellRendererParams } from "ag-grid-community";
import { useTheme } from "@mui/material/styles";
import Cisco_img from "../../assets/baseVersion/cisco.svg";
import Paloalto_img from "../../assets/baseVersion/paloalto.svg";
//  import arista_assets from "../../assets/arista-assets.svg";
import juniper_assets from "../../assets/juniper.svg";
import Paloalto_dark from "../../assets/palaoto_dark.svg";
import AWS_img from "../../assets/baseVersion/aws.svg";
import arista_dark from "../../assets/arista_dark.svg";
import arista_img from "../../assets/baseVersion/arista.svg";
import juniper_dark from "../../assets/baseVersion/dark_juniper.svg";
import axiosInstance from "../../axios/axios";
import AgGridTable from "../table/AgGridTable";
import CVEDetailsPanel from "./CVEDetailsPanel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import fortinet_img from "../../assets/fortinet.svg";
import fortinet_scan_dark from "../../assets/fortinet-white-1.svg"
import sophosLogo from "../../assets/sophos.svg";
import sophos_dark from "../../assets/sophos-white.svg";
import ubuntu from "../../assets/ubuntu.svg";
import Windows_light from "../../assets/baseVersion/Windows_light.svg";
import windows_dark from "../../assets/baseVersion/Windows_dark.svg"
import ubuntu_dark from "../../assets/ubuntu_dark.svg";
import ubuntu_light from "../../assets/ubuntu_white.svg";
import debian from "../../assets/debian.svg";
import debian_dark from "../../assets/debian_dark.svg";
import redhat_light from "../../assets/redhat_light.svg";
import redhat_dark from "../../assets/redhat_dark.svg";
import huawei_light from "../../assets/huawei-ar21 1.svg";
import huawei_dark from "../../assets/huawei-dark.svg";
import mikrotik from "../../assets/mikrotik.svg";
import mikrotik_dark from "../../assets/mikrotik_dark.svg";
import edgecore_logo from "../../assets/baseVersion/edgecore-logo.svg";
import tplink_light from "../../assets/baseVersion/TPLINK_Logo_2 1.svg";
import tplink_dark from "../../assets/baseVersion/TPLINK_Logo_dark.svg";
import apple_img from "../../assets/apple.svg";
import apple_dark from "../../assets/apple_dark.svg";
import dell_logo from "../../assets/baseVersion/dell-seeklogo 2.svg";
import syrotech_light from "../../assets/syrotech_light.svg";
import syrotech_dark from "../../assets/syrotech_dark.svg";
import AWS_DARK from "../../assets/baseVersion/AWS_DARK.svg"
import { minWidth } from "@mui/system";
import { min } from "lodash";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cve-tabpanel-${index}`}
      aria-labelledby={`cve-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

interface CVEDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  cveData: {
    cve_id: string;
    severity: string;
    cvss_score: number;
    affected_assets: number;
    cisa_key: string;
    summaryData?: {
      id: string;
      cve_summary: string;
      cve_details: {
        vulnerability_name: string | null;
        date_added: string | null;
        due_date: string | null;
        required_action: string | null;
      };
      cve_summary_desc: string | null;
      nvd_pd: string;
      nvd_lmd: string;
      source: string;
      severity: string;
      epss_details: {
        pea: number;
        pov: number;
      };
      reference: Array<{
        hyperlinks: {
          label: string;
          link: string;
          resources: string;
        };
      }>;
      severity_metrics: Array<{
        name: string;
        key: string;
        authority: Array<{
          name: string;
          key: string;
        }>;
        score: {
          nvd: Array<{
            name: string;
            value: number | string;
          }>;
          cisco: Array<{
            name: string;
            value: number | string;
          }>;
        };
        value: {
          nvd: Array<{
            name: string;
            value: string;
            row: number;
            col: number;
          }>;
          cisco: Array<{
            name: string;
            value: string;
            row: number;
            col: number;
          }>;
        };
      }>;
      weakness_enumeration: Array<{
        cwe_id: string;
        cwe_name: string;
        source: string;
      }>;
      known_affected_sc: Array<{
        cpe: string;
        from: string;
        from_include: boolean;
        to: string;
        to_include: boolean;
      }>;
      cisa_data_available: boolean;
      epss_data_available: boolean;
    };
  };
  isNavigationFromAssets?: boolean;
  showBackButton?: boolean;
  showComponentsTab?: boolean;
  initialTabIndex?: number;
  drawerWidth?: string | number;
  drawerMaxWidth?: string | number;
  assetIds?: string[];
  inactiveAssetIds?: string[];
  disableAssetClick?: boolean;
}

const CVEDetailsDrawer: React.FC<CVEDetailsDrawerProps> = ({
  open,
  onClose,
  isLoading,
  cveData,
  isNavigationFromAssets = false,
  showBackButton,
  showComponentsTab = false,
  initialTabIndex = 0,
  drawerWidth,
  drawerMaxWidth,
  assetIds = [],
  inactiveAssetIds = [],
  disableAssetClick = false,
}) => {
  const [tabValue, setTabValue] = useState(initialTabIndex);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedAsset, setSelectedAsset] = useState<any>(null);
  const [assetDrawerOpen, setAssetDrawerOpen] = useState(false);
  const [reportDrawerOpen, setReportDrawerOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleAssetRowClick = (row: any) => {
    if (disableAssetClick) return;
    console.log("Asset row clicked from CVE Details Drawer:", row);
    // Construct robust assetData shape expected by AssetDetailsDrawer
    const mappedAsset = {
      id: row.id || row.asset_id || row.device_id || row.device_uuid || row.uuid,
      device_name: row.device_name || row.asset_name || "",
      device_type: row.device_type || row.asset_type || "",
      vendor: row.vendor || row.Manufacturer || "",
      region_name: row.region_name || "Unassigned",
      cve: row.cve || 0,
      cve_last_modified: row.cve_last_modified || "",
      security_score: row.security_score,
      last_scan: row.last_scan || row.detected_date || "",
      vulnerability: row.vulnerability || 0,
      status: row.status,
      criticality: row.criticality || "",
      vulnerability_levels: row.vulnerability_levels,
    };
    setSelectedAsset(mappedAsset);
    setAssetDrawerOpen(true);
  };

  const handleMenuKebabClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuKebabClose = () => {
    setMenuAnchorEl(null);
  };

  const handleShowConfig = (deviceId: any, selectDevice: any = null) => {
    dispatch(
      setConfigDiffData({
        rowData: selectDevice,
        device_id: String(deviceId),
        click: "assets",
      })
    );
    navigate(`/on-premises/configdiff`, {
      state: { device_id: String(deviceId) }
    });
  };

  const handleMenuAction = (action: string) => {
    switch (action) {
      case "ShowConfigDiff":
        if (selectedAsset?.id) {
          handleShowConfig(selectedAsset.id, selectedAsset);
        }
        break;
    }
    handleMenuKebabClose();
  };

  const handleAssetComplianceReport = () => {
    setAssetDrawerOpen(false);
    setReportDrawerOpen(true);
  };

  const MenuKebabDrawer = (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <IconButton
        size="small"
        onClick={handleMenuKebabClick}
        sx={{
          color: "text.secondary",
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={handleMenuKebabClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            width: 200,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <MenuItem onClick={() => handleMenuAction("ShowConfigDiff")}>
          Show Config Diff
        </MenuItem>
      </Menu>
    </Box>
  );

  useEffect(() => {
    const handleCloseAll = () => {
      setAssetDrawerOpen(false);
      setReportDrawerOpen(false);
      onClose();
    };
    eventEmitter.on("closeAllDrawers", handleCloseAll);
    return () => {
      eventEmitter.off("closeAllDrawers", handleCloseAll);
    };
  }, [onClose]);

  // Update tabValue when initialTabIndex changes (e.g. when opening a new CVE with a specific intent)
  useEffect(() => {
    if (open) {
      setTabValue(initialTabIndex);
    }
  }, [initialTabIndex, open]);

  const [cvssVersion, setCvssVersion] = useState(() => {
    const availableVersions = (cveData.summaryData?.severity_metrics || []).filter(
      (metric) => {
        // Check if the metric has any meaningful data
        const hasAuthority = metric.authority && metric.authority.length > 0;
        const hasScoreData = metric.score && Object.keys(metric.score).length > 0;
        const hasValueData = metric.value && Object.keys(metric.value).length > 0;

        // Show if it has any of these: authority, score data, or value data
        return hasAuthority || hasScoreData || hasValueData;
      }
    );
    return availableVersions?.[0]?.key || "cvssMetricV31";
  });
  const [authority, setAuthority] = useState(() => {
    const selectedVersion = cveData.summaryData?.severity_metrics?.find(
      (metric) => metric.key === cvssVersion
    );
    return selectedVersion?.authority?.[0]?.key || "nvd";
  });

  // Mock data for components
  const mockComponents = [
    {
      component_name: "Apache HTTP Server",
      version: "2.4.41",
      vendor: "Apache Software Foundation",
      criticality: "High"
    },
    {
      component_name: "OpenSSL",
      version: "1.1.1f",
      vendor: "OpenSSL Software Foundation",
      criticality: "Critical"
    },
    {
      component_name: "MySQL Server",
      version: "8.0.25",
      vendor: "Oracle Corporation",
      criticality: "Medium"
    },
    {
      component_name: "Node.js",
      version: "14.17.0",
      vendor: "Node.js Foundation",
      criticality: "Low"
    },
    {
      component_name: "Python",
      version: "3.9.5",
      vendor: "Python Software Foundation",
      criticality: "Medium"
    },
    {
      component_name: "Docker Engine",
      version: "20.10.7",
      vendor: "Docker Inc.",
      criticality: "High"
    },
    {
      component_name: "Redis",
      version: "6.2.4",
      vendor: "Redis Labs",
      criticality: "Low"
    },
    {
      component_name: "Nginx",
      version: "1.20.1",
      vendor: "Nginx Inc.",
      criticality: "Medium"
    }
  ];

  const [affectedAssets, setAffectedAssets] = useState<any[]>([]);
  const [affectedAssetsCount, setAffectedAssetsCount] = useState(0);
  const [componentCount, setComponentCount] = useState(0);
  const [isLoadingAssets, setIsLoadingAssets] = useState(false);

  // State to track current CVE ID for derived state reset
  const [prevCveId, setPrevCveId] = useState(cveData.cve_id);

  // Derived state pattern: Reset state if cve_id changes during render
  if (cveData.cve_id !== prevCveId) {
    setPrevCveId(cveData.cve_id);
    setAffectedAssets([]);
    setAffectedAssetsCount(0);
    setComponentCount(0);
    setIsLoadingAssets(false);
  }

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Get current version metrics
  const getCurrentVersionMetrics = () => {
    return cveData.summaryData?.severity_metrics?.find(
      (metric) => metric.key === cvssVersion
    );
  };

  // Update authority when CVSS version changes
  useEffect(() => {
    const selectedVersion = getCurrentVersionMetrics();
    if (
      selectedVersion &&
      selectedVersion.authority &&
      selectedVersion.authority.length > 0
    ) {
      // Only set authority if it's not already set or if current authority is not available for this CVSS version
      const currentAuthorityExists = selectedVersion.authority.some((auth: any) => auth.key === authority);
      if (!authority || !currentAuthorityExists) {
        setAuthority(selectedVersion.authority[0].key);
      }
    }
  }, [cvssVersion, cveData.summaryData?.severity_metrics]);

  const fetchAffectedAssets = async () => {
    setIsLoadingAssets(true);
    try {
      if ((assetIds && assetIds.length > 0) || (inactiveAssetIds && inactiveAssetIds.length > 0)) {
        const payload = {
          asset_ids: assetIds || [],
          inactive_asset_ids: inactiveAssetIds || []
        };
        
        const response = await axiosInstance.post(`securityscan/wmi-asset-level/asset-details`, payload);
        
        if (response.data?.results) {
          setAffectedAssets(response.data.results || []);
          setAffectedAssetsCount(response.data.results.length || 0);
          setComponentCount(mockComponents.length || 0);
        }
      } else {
        const payload = { cve: cveData.cve_id, type: 1 };
        const response = await axiosInstance.post(
          "securityscan/cve/af_list",
          payload
        );

        if (response.data.status === 200) {
          setAffectedAssets(response.data.data.parameters || []);
          setAffectedAssetsCount(response.data.data.affected_assets_list || 0);
          setComponentCount(mockComponents.length || 0);
        }
      }
    } catch (error) {
      console.error("Error fetching affected assets:", error);
    } finally {
      setIsLoadingAssets(false);
    }
  };

  useEffect(() => {
    if (open && cveData.cve_id) {
      setAffectedAssets([]); // Clear previous data
      fetchAffectedAssets();
    }
  }, [open, cveData.cve_id]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Update the column definitions for assets table

  // cellRenderer: (params: ICellRendererParams) => {
  //     // Determine criticality color based on some metric (e.g. CVE count or security score)
  //     let criticalityColor = "#22C55E"; // Default green
  //     if (params.data.cve > 5) {
  //       criticalityColor = "#F97316"; // Orange for high
  //     } else if (params.data.cve > 2) {
  //       criticalityColor = "#EAB308"; // Yellow for medium
  //     }

  //     return (
  //       <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
  //         <Box
  //           sx={{
  //             width: "4px",
  //             height: "24px",
  //             backgroundColor: criticalityColor,
  //             borderRadius: "2px",
  //           }}
  //         />
  //         <Typography variant="body2">{params.value}</Typography>
  //       </Box>
  //     );
  //   },
  const assetColumnDefs = (assetIds && assetIds.length > 0) ? [
    {
      field: "asset_name",
      headerName: "Asset Name",
      flex: 1,
      minWidth: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: ICellRendererParams) => {
        const value = params.value || "";
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%" }}>
            {/* <div style={{ width: "4px", height: "32px", backgroundColor: "#00A61B", borderRadius: "2px", marginRight: "8px", flexShrink: 0 }} /> */}
            <Tooltip title={value} arrow slotProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "#000", boxShadow: 1, fontSize: "0.775rem" } }, arrow: { sx: { color: "#fff" } } }}>
              <Typography variant="body2" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>{value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "region_name",
      headerName: "Region",
      minWidth: 150,
      flex: 1.2,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "Unassigned";
        return (
          <Tooltip title={value} arrow slotProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "#000", boxShadow: 1, fontSize: "0.775rem" } }, arrow: { sx: { color: "#fff" } } }}>
            <Typography variant="body2" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}>{value}</Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "model",
      headerName: "Model",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "vendor",
      headerName: "Vendor",
      minWidth: 120,
      flex: 1,
      valueGetter: (params: any) => params.data.Manufacturer || params.data.vendor,
      cellRenderer: (params: any) => {
        const value = params.value?.toLowerCase();
        let imgSrc = "";

        if (value === "cisco") imgSrc = Cisco_img;
        else if (value === "palo alto" || value === "paloalto") imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
        else if (value === "amazon web services") imgSrc = isDarkMode ? AWS_DARK : AWS_img;
        else if (value === "arista") imgSrc = isDarkMode ? arista_dark : arista_img;
        else if (value === "juniper") imgSrc = isDarkMode ? juniper_dark : juniper_assets;
        else if (value === "fortinet") imgSrc = isDarkMode ? fortinet_scan_dark : fortinet_img;
        else if (value === "sophos") imgSrc = isDarkMode ? sophos_dark : sophosLogo;
        else if (value === "ubuntu") imgSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
        else if (value === "microsoft") imgSrc = isDarkMode ? windows_dark : Windows_light;
        else if (value === "debian") imgSrc = isDarkMode ? debian_dark : debian;
        else if (value === "redhat") imgSrc = isDarkMode ? redhat_dark : redhat_light;
        else if (value === "huawei") imgSrc = isDarkMode ? huawei_dark : huawei_light;
        else if (value === "mikrotik") imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
        else if (value === "edgecore") imgSrc = edgecore_logo;
        else if (value === "tp-link" || value === "tplink") imgSrc = isDarkMode ? tplink_dark : tplink_light;
        else if (value === "apple" || value === "macos") imgSrc = isDarkMode ? apple_dark : apple_img;
        else if (value === "dell") imgSrc = dell_logo;
        else if (value === "syrotech") imgSrc = isDarkMode ? syrotech_dark : syrotech_light;

        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
            {imgSrc ? (
              <img
                src={imgSrc}
                alt={value}
                style={{ width: 80, height: value === "huawei" ? 30 : 20, marginRight: 2, objectFit: "contain" }}
              />
            ) : (
              <Typography variant="body2">{params.value || '-'}</Typography>
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ] : [
    {
      field: "asset_name",
      headerName: "Asset Name",
      flex: 1,
      minWidth: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: ICellRendererParams) => {
        const value = params.value || "";
        const criticalityColors: any = {
          critical: "#B71E31",
          high: "#FF6600",
          medium: "#E0B102",
          low: "#00A61B",
          default: "#B71E31",
        };

        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, width: "100%" }}>
            <div style={{ width: "4px", height: "32px", backgroundColor: criticalityColors[params?.data?.criticality?.toLowerCase()] || "#B71E31", borderRadius: "2px", marginRight: "8px", flexShrink: 0 }} />
            <Tooltip title={value} arrow slotProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "#000", boxShadow: 1, fontSize: "0.775rem" } }, arrow: { sx: { color: "#fff" } } }}>
              <Typography variant="body2" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>{value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "region_name",
      headerName: "Region",
      minWidth: 150,
      flex: 1.2,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: any) => {
        const value = params.value || "";
        return (
          <Tooltip title={value} arrow slotProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "#000", boxShadow: 1, fontSize: "0.775rem" } }, arrow: { sx: { color: "#fff" } } }}>
            <Typography variant="body2" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}>{value}</Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "asset_type",
      headerName: "Asset Types",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "vendor",
      headerName: "Vendor",
      minWidth: 120,
      flex: 1,
      cellRenderer: (params: any) => {
        const value = params.value?.toLowerCase();
        let imgSrc = "";

        if (value === "cisco") imgSrc = Cisco_img;
        else if (value === "palo alto" || value === "paloalto") imgSrc = isDarkMode ? Paloalto_dark : Paloalto_img;
        else if (value === "amazon web services") imgSrc = isDarkMode ? AWS_DARK : AWS_img;
        else if (value === "arista") imgSrc = isDarkMode ? arista_dark : arista_img;
        else if (value === "juniper") imgSrc = isDarkMode ? juniper_dark : juniper_assets;
        else if (value === "fortinet") imgSrc = isDarkMode ? fortinet_scan_dark : fortinet_img;
        else if (value === "sophos") imgSrc = isDarkMode ? sophos_dark : sophosLogo;
        else if (value === "ubuntu") imgSrc = isDarkMode ? ubuntu_dark : ubuntu_light;
        else if (value === "microsoft") imgSrc = isDarkMode ? windows_dark : Windows_light;
        else if (value === "debian") imgSrc = isDarkMode ? debian_dark : debian;
        else if (value === "redhat") imgSrc = isDarkMode ? redhat_dark : redhat_light;
        else if (value === "huawei") imgSrc = isDarkMode ? huawei_dark : huawei_light;
        else if (value === "mikrotik") imgSrc = isDarkMode ? mikrotik_dark : mikrotik;
        else if (value === "edgecore") imgSrc = edgecore_logo;
        else if (value === "tp-link" || value === "tplink") imgSrc = isDarkMode ? tplink_dark : tplink_light;
        else if (value === "apple" || value === "macos") imgSrc = isDarkMode ? apple_dark : apple_img;
        else if (value === "dell") imgSrc = dell_logo;
        else if (value === "syrotech") imgSrc = isDarkMode ? syrotech_dark : syrotech_light;

        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
            {imgSrc && (
              <img
                src={imgSrc}
                alt={value}
                style={{ width: 80, height: value === "huawei" ? 30 : 20, marginRight: 2, objectFit: "contain" }}
              />
            )}
          </div>
        );
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  // Column definitions for components table
  const componentColumnDefs = [
    {
      field: "component_name",
      headerName: "Component Name",
      flex: 1.5,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
      cellRenderer: (params: ICellRendererParams) => {
        const value = params.value || "";
        const criticalityColors: any = {
          critical: "#B71E31",
          high: "#FF6600",
          medium: "#E0B102",
          low: "#00A61B",
          default: "#B71E31",
        };

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              width: "100%",
            }}
          >
            <div
              style={{
                width: "4px",
                height: "32px",
                backgroundColor:
                  criticalityColors[params?.data?.criticality?.toLowerCase()] ||
                  "#B71E31",
                borderRadius: "2px",
                marginRight: "8px",
                flexShrink: 0,
              }}
            />
            <Tooltip
              title={value}
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff",
                    color: "#000",
                    boxShadow: 1,
                    fontSize: "0.775rem",
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  flex: 1,
                }}
              >
                {value}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "version",
      headerName: "Version",
      flex: 1,
      cellRenderer: (params: any) => {
        const value = params.value || "";
        return (
          <Tooltip
            title={value}
            arrow
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#000",
                  boxShadow: 1,
                  fontSize: "0.775rem",
                },
              },
              arrow: {
                sx: {
                  color: "#fff",
                },
              },
            }}
          >
            <Typography
              variant="body2"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              {value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "vendor",
      headerName: "Vendor",
      flex: 1.2,
    },
    {
      field: "criticality",
      headerName: "Criticality",
      flex: 1,
      cellRenderer: (params: any) => {
        const value = params.value || "";
        const criticalityColors: any = {
          critical: "#B71E31",
          high: "#FF6600",
          medium: "#E0B102",
          low: "#00A61B",
        };

        return (
          <Chip
            label={value}
            size="small"
            sx={{
              bgcolor: criticalityColors[value.toLowerCase()] + "24",
              color: criticalityColors[value.toLowerCase()],
              fontWeight: 600,
              fontSize: 12,
            }}
          />
        );
      },
    },
  ];

  // Update the mockChips with real data
  const getMetricsFromSummary = () => {
    // if (!cveData.summaryData?.vulnerability_details) return mockChips;
    // const vd = cveData.summaryData.vulnerability_details;
    // return [
    //   { label: vd.attack_vector, color: "#DC2626" },
    //   { label: vd.attack_complexity, color: "#22C55E" },
    //   { label: vd.privileges_required, color: "#3B82F6" },
    //   { label: vd.user_interaction, color: "#F97316" },
    //   { label: vd.scope, color: "#6B7280" },
    // ];
    const array: any = [
      { label: cveData.severity, color: "#3B82F6", showDot: true },
    ];
    if (cveData?.cisa_key) {
      array.push({
        label: "CISA's Known Exploited Vulnerabilities",
        color: "#DC2626",
        showDot: false,
      });
    }
    return array;
  };

  // Get the actual metrics
  const chips = getMetricsFromSummary();

  // If navigation is from assets, always show tab 0 and hide tabs
  const showTabs = !isNavigationFromAssets;
  const currentTab = isNavigationFromAssets ? 0 : tabValue;

  return (
    <>
      {!isNavigationFromAssets ? (
        <>
          <Drawer
            anchor="right"
            open={open}
            onClose={(event, reason) => {
              if (reason === "backdropClick" || reason === "escapeKeyDown") {
                eventEmitter.emit("closeAllDrawers");
              } else {
                onClose();
              }
            }}
            PaperProps={{
              sx: {
                // width: 700,
                width: drawerWidth ?? "50%",
                ...(drawerMaxWidth ? { maxWidth: drawerMaxWidth } : {}),
                // borderRadius: "16px",
                // m: 1,
                // height: "calc(100% - 16px)",
                overflow: "hidden",
                bgcolor: theme.palette.mode === "dark" ? "#1E1E1E" : "#FFFFFF",
              },
            }}
          >
            {/* Sticky Header */}
            {!isNavigationFromAssets && (
              <>
                <Box
                  className="no-drag"
                  sx={{
                    position: "sticky",
                    top: 0,
                    // bgcolor: "background.paper",
                    zIndex: 1200,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    p: 1,
                    ml: 2,
                    pb: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {showBackButton && (
                        <ArrowBackIcon
                          sx={{ cursor: "pointer", mr: 1 }}
                          onClick={onClose}
                        />
                      )}
                      <Typography variant="h6" fontWeight="bold">
                        {cveData.cve_id}
                      </Typography>
                    </div>
                    <IconButton onClick={onClose} sx={{ ml: 2 }}>
                      <CloseIcon />
                    </IconButton>
                  </Box>

                  {/* Chips */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                      borderBottom: 1,
                      borderColor: "divider",
                    }}
                  >
                    {/* const severityStyles: any = {
          Critical: { bgcolor: isDarkMode ? "rgba(255, 61, 61, 0.18)" : "#67000424", color: isDarkMode ? "#FF3D3D" : "#670004" },
    High: { bgcolor: isDarkMode ? "rgba(255, 107, 107, 0.15)" : "#A7000F24", color: isDarkMode ? "#FF6B6B" : "#A7000F" },
    Medium: { bgcolor: isDarkMode ? "rgba(255, 167, 38, 0.15)" : "#E8580024", color: isDarkMode ? "#FFA726" : "#E85800" },
    Low: { bgcolor: isDarkMode ? "rgba(255, 224, 130, 0.15)" : "#F2BF0024", color: isDarkMode ? "#FFE082" : "#F2BF00" },
  }; */}
                    {chips.map((chip: any, index: any) => {
                      let chipColor = "#6B7280";
                      let bgColor = "#67000424";

                      if (isDarkMode) {
                        switch (chip.label.toLowerCase()) {
                          case "critical":
                            chipColor = "#FF3D3D";
                            bgColor = "rgba(255, 61, 61, 0.18)";
                            break;
                          case "high":
                            chipColor = "#FF6B6B";
                            bgColor = "rgba(255, 107, 107, 0.15)";
                            break;
                          case "medium":
                            chipColor = "#FFA726";
                            bgColor = "rgba(255, 167, 38, 0.15)";
                            break;
                          case "low":
                            chipColor = "#FFE082";
                            bgColor = "rgba(255, 224, 130, 0.15)";
                            break;
                          default:
                            chipColor = "#FF3D3D";
                            bgColor = "rgba(255, 61, 61, 0.18)";
                        }
                      } else {
                        switch (chip.label.toLowerCase()) {
                          case "critical":
                            chipColor = "#670004";
                            bgColor = "#67000424";
                            break;
                          case "high":
                            chipColor = "#A7000F";
                            bgColor = "#A7000F24";
                            break;
                          case "medium":
                            chipColor = "#E85800";
                            bgColor = "#E8580024";
                            break;
                          case "low":
                            chipColor = "#F2BF00";
                            bgColor = "#F2BF0024";
                            break;
                          default:
                            chipColor = "#670004";
                            bgColor = "#67000424";
                        }
                      }

                      return chip?.showDot ? (
                        <Chip
                          key={index}
                          label={chip.label}
                          size="small"
                          icon={
                            <FiberManualRecordIcon
                              sx={{
                                fontSize: 12,
                                color: `${chipColor} !important`,
                              }}
                            />
                          }
                          sx={{
                            borderRadius: 1,
                            mb: 1,
                            bgcolor: bgColor,
                            color: chipColor,
                            fontWeight: 600,
                            fontSize: 14,
                            px: 1.5,
                            height: 32,
                          }}
                        />
                      ) : (
                        <Chip
                          key={index}
                          label={chip.label}
                          size="small"
                          sx={{
                            borderRadius: 1,
                            mb: 1,
                            bgcolor: bgColor,
                            color: isDarkMode ? "#FF3D3D" : `#960006`,
                            fontWeight: 600,
                            fontSize: 14,
                            px: 1.5,
                            height: 32,
                          }}
                        />
                      );
                    })}
                  </Box>

                  {/* Tabs */}
                  {showTabs && (
                    <Box
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        fontWeight: 800,
                        fontSize: 14,
                      }}
                    >
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{
                          "& .MuiTab-root": {
                            color:
                              theme.palette.mode === "dark"
                                ? "#FFFFFF"
                                : "#3A2ADA",
                            fontWeight: 800,
                            fontSize: 14,
                            "&.Mui-selected": {
                              color:
                                theme.palette.mode === "dark"
                                  ? "#FFFFFF"
                                  : "#3A2ADA",
                            },
                          },
                          "& .MuiTabs-indicator": {
                            backgroundColor:
                              theme.palette.mode === "dark"
                                ? "#FFFFFF"
                                : "primary.main",
                          },
                        }}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor:
                              theme.palette.mode === "dark"
                                ? "#FFFFFF"
                                : undefined,
                          },
                        }}
                      >
                        <Tab label="Details" />
                        <Tab label={`Assets (${affectedAssetsCount})`} />
                        {showComponentsTab && (
                          <Tab label={`Components (${componentCount})`} />
                        )}
                      </Tabs>
                    </Box>
                  )}
                </Box>
              </>
            )}

            {/* Scrollable Content */}
            <Box
              className="scroll"
              sx={{
                overflow: "auto",
                height: "100%",
                // padding: "10px",
                // "&::-webkit-scrollbar": {
                //   width: "4px",
                // },
                // "&::-webkit-scrollbar-track": {
                //   backgroundColor: "transparent",
                // },
                // "&::-webkit-scrollbar-thumb": {
                //   backgroundColor: "#bdbdbd",
                //   borderRadius: "4px",
                // },
              }}
            >
              {currentTab === 0 && (
                <TabPanel value={currentTab} index={0} className="no-drag">
                  <CVEDetailsPanel cveData={cveData} isLoading={isLoading} />
                </TabPanel>
              )}
              {showTabs && currentTab === 1 && (
                <TabPanel value={currentTab} index={1} className="no-drag">
                  <Box>
                    <AgGridTable
                      data={affectedAssets}
                      columnDefs={assetColumnDefs}
                      isLoading={isLoadingAssets}
                      pagination={true}
                      showSearch={true}
                      height="calc(100vh - 200px)"
                      onRowClick={disableAssetClick ? undefined : handleAssetRowClick}
                      gridOptions={{
                        rowStyle: {
                          background: "white",
                          cursor: disableAssetClick ? "default" : "pointer",
                        },

                        getRowStyle: (params) => ({
                          background:
                            params.node?.rowIndex! % 2 === 0
                              ? "#FFFFFF"
                              : "#F9FAFB",
                        }),
                      }}
                    />
                  </Box>
                </TabPanel>
              )}
              {showTabs && showComponentsTab && currentTab === 2 && (
                <TabPanel value={currentTab} index={2} className="no-drag">
                  <Box>
                    <AgGridTable
                      data={mockComponents}
                      columnDefs={componentColumnDefs}
                      isLoading={isLoadingAssets}
                      pagination={true}
                      showSearch={true}
                      height="calc(100vh - 200px)"
                      gridOptions={{
                        rowStyle: { background: "white" },
                        getRowStyle: (params) => ({
                          background:
                            params.node?.rowIndex! % 2 === 0
                              ? "#FFFFFF"
                              : "#F9FAFB",
                        }),
                      }}
                    />
                  </Box>
                </TabPanel>
              )}
            </Box>
          </Drawer>
        </>
      ) : (
        <></>
      )}
      {isNavigationFromAssets && currentTab === 0 && (
        <>
          <CVEDetailsPanel
            cveData={cveData}
            isLoading={isLoading}
            isNavigationFromAssets={true}
          />
        </>
      )}

      {/* Asset Details Drawer */}
      <React.Suspense fallback={null}>
        <AssetDetailsDrawer
          open={assetDrawerOpen}
          onClose={() => {
            setAssetDrawerOpen(false);
          }}
          assetData={selectedAsset}
          isCloud={false}
          isMenu={MenuKebabDrawer}
          onReport={handleAssetComplianceReport}
          isCve={true}
        />
      </React.Suspense>

      <Drawer
        anchor="right"
        open={reportDrawerOpen}
        onClose={() => setReportDrawerOpen(false)}
        PaperProps={{ sx: { width: 400, borderRadius: 2 } }}
      >
        <AssetComplianceReportDrawer
          onClose={() => setReportDrawerOpen(false)}
          assetData={selectedAsset}
        />
      </Drawer>
    </>
  );
};

export default CVEDetailsDrawer;
